module.exports = __webpack_public_path__ + "img/section2.c4d4a6fa.jpg";